export default {
  userProfile: 'user-profile',
  organizationOnboarding: 'organization-onboarding',
  campaignsList: 'campaigns-list',
  campaignsForFilter: 'campaignsForFilter',
  agentsList: 'agents-list',
  activityLogs: 'activity-logs',
  templates: 'templates',
  templatesSteps: 'templates',
  integrationsList: 'integrations-list',
  listApiKeys: 'list-api-keys',
  listWebhookEndpoints: 'list-webhook-endpoints',
  listWebhookDeliveries: 'list-webhook-deliveries',
  // orders
  orders: 'orders',
  orderFolders: 'order-folders',
  orderDetails: 'order-details',
  orderPricing: 'order-pricing',
  // backlinks
  backlinks: 'backlinks',
  orderItemConcern: 'order-item-concern',
  domainApprovalReview: 'domain-approval-review',
  articles: 'articles',
  publisherWebsites: 'publisher-websites',
  publisherWebsiteImport: 'publisher-website-import',
  publisherOrderChangeRequest: 'publisher-order-change-request',
  // campaigns
  campaigns: 'campaigns',
  campaignAnalyticsOverview: 'campaignAnalyticsOverview',
  campaignPromptAnalytics: 'campaignPromptAnalytics',
  conciergeCampaignDetail: 'conciergeCampaignDetail',
};
